import React from 'react';
import { Link, useParams, Navigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useCourse } from '../../../hooks/admin/useCourse';
import { useAdmin } from '../../../hooks/admin/useAdmin';
import { LoadingScreen } from '../../../components/common/LoadingScreen';
import { ModuleManager } from '../../../components/admin/courses/ModuleManager';

export function EditModulesPage() {
  const { courseId } = useParams();
  const { course, isLoading, error } = useCourse(courseId);
  const { isAdmin } = useAdmin();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  if (error || !course) {
    return (
      <div className="min-h-screen bg-background-dark py-8">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h1 className="text-2xl font-bold text-white mb-4">Course not found</h1>
          <Link to="/admin/courses" className="text-accent-green hover:opacity-80">
            Back to Courses
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background-dark py-8">
      <div className="max-w-7xl mx-auto px-4">
        <div className="mb-6">
          <Link
            to="/admin/courses"
            className="inline-flex items-center text-accent-green hover:opacity-80"
          >
            <ArrowLeft className="h-5 w-5 mr-2" />
            Back to Courses
          </Link>
        </div>

        <div className="bg-background-card rounded-xl border border-gray-800">
          <div className="p-6">
            <h1 className="text-2xl font-bold text-white mb-4">
              {course.title} - Module Management
            </h1>
            <p className="text-gray-400 mb-8">
              Add and manage modules and lessons for this course
            </p>
            
            <ModuleManager
              courseId={course.id}
              modules={course.modules || []}
              onModulesChange={(updatedModules) => {
                // Handle module changes if needed
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}